import React from "react";

import { addressValidationPattern } from "@gp/common";

import { FormInputField } from "@components-shared/desktop/inputs";

export default function OnboardingRegistrationStreet(props: {
	labelClassName?: string;
}) {
	const { labelClassName } = props;

	return (
		<FormInputField
			id="streetName"
			className="form__field u-mar--bottom--reset"
			inputClassName="input input--sml"
			name="street"
			label="registration:STREET_LABEL"
			labelClassName={labelClassName}
			placeholder="registration:STREET_PLACEHOLDER"
			pattern={{
				value: addressValidationPattern,
				message: "registration:STREET_CHARACTER",
			}}
			required
		/>
	);
}
